module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_an-769a38da65f23b7a03d4fd8f9dd0e660.webp";